import { GetterTree } from 'vuex'

import { OffersState } from './types'
import { RootState } from '../types'
import { Seller, Offer, OfferItem } from '@/types'

export const getters: GetterTree<OffersState, RootState> = {
  getOffer(state): Offer | null {
    return state.offer
  },
}
